import Atta from '@/reporter/Atta';
import { getReportInfo } from '@/utils/serviceInfo';
const SYSTEM_ATTA = {
    attaId: '03c00058181',
    attaToken: '5384471396',
};
/** 上报前去掉 URL 中的 resumeToken（连接凭证）。 */
export function stripResumeToken(url) {
    try {
        const parsed = new URL(url);
        parsed.searchParams.delete('resumeToken');
        return parsed.toString();
    }
    catch {
        return url.replace(/([?&])resumeToken=[^&]*&?/g, '$1').replace(/[?&]$/, '');
    }
}
/** live wsUrl 预览的 Hub 连接变化。走 runtime Atta，不进编辑器 DesignerReport，也不记 PV。 */
export function reportGogoRemoteHubConnection(payload) {
    const configs = window.RUNTIME_CONFIGS;
    const projectId = configs?.projectId;
    const pageId = configs?.pageId;
    if (!projectId || !pageId) {
        return;
    }
    const custom = getReportInfo()?.atta;
    const atta = new Atta({
        attaId: custom?.id || SYSTEM_ATTA.attaId,
        token: custom?.token || SYSTEM_ATTA.attaToken,
        getPublicDims: () => ({ env: configs.env }),
    });
    atta.setProject({ projectId });
    atta.setPage(pageId);
    void atta.report('customEvent', {
        eid: payload.state,
        subAction: 'gogoHubConnection',
        surface: 'runtime',
        d1: String(payload.attempt),
        d2: payload.isReconnect ? '1' : '0',
        d3: String(payload.consecutiveFailures),
        d4: payload.lastError,
        d5: stripResumeToken(payload.url),
        d6: String(payload.reconnectDelayMs),
    });
}
